import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChatcontextProvider } from './context/notes/Chatcontext';
import NoteState from './context/notes/NoteState';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <NoteState>
  <ChatcontextProvider>
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </ChatcontextProvider>
  </NoteState>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
